import React from 'react';
import { AsyncAutosuggest } from 'components';

const EditorialAutosuggest = ({ value, label, handleChange }) => (
	<AsyncAutosuggest
		name="editorial_id"
		label={label}
		value={value}
		displayField="title"
		remoteUrl="/api/v1/admin/editorials"
		placeholder="Select"
		handleChange={handleChange}
	/>
);

export default EditorialAutosuggest;
